import EmitirNotaMogi from '../../components/EmitirNotaMogi';

const EmitirMogiPage = () => {
  return (
    <div style={{padding: 32}}>
      <EmitirNotaMogi />
    </div>
  );
};

export default EmitirMogiPage;
